<div class="list-toolbar">
  <mat-form-field appearance="outline" class="filter" subscriptSizing="dynamic">
    <mat-label>Status</mat-label>
    <mat-select [(ngModel)]="status" (selectionChange)="onFilterChange()">
      <mat-option value="">All</mat-option>
      <mat-option value="Pending">Pending</mat-option>
      <mat-option value="Paid">Paid</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-button-toggle-group class="date-by" [(ngModel)]="dateBy" (change)="onDateByChange()"
    matTooltip="Which day the From/To dates filter on. 'Paid' counts days as the Hesabfa export does.">
    <mat-button-toggle value="created">Recorded on</mat-button-toggle>
    <mat-button-toggle value="paid">Paid on</mat-button-toggle>
  </mat-button-toggle-group>
  <p class="hint">
    <mat-icon>info</mat-icon>
    These records track what was paid.
  </p>
  <span class="spacer"></span>
  @if (canEdit) {
  <button mat-stroked-button type="button" (click)="recordManual()">
    <mat-icon>add_card</mat-icon> Manual payment
  </button>
  }
  <button mat-stroked-button type="button" (click)="exportReport()">
    <mat-icon>download</mat-icon> Export Excel
  </button>
</div>

<div class="table-card">
@if (loading) {
<div class="table-state"><mat-spinner diameter="28"></mat-spinner></div>
} @else if (error) {
<div class="table-state error">{{ error }}</div>
} @else if (settlements.length === 0) {
<div class="table-state">No settlements match these filters.</div>
} @else {

@if (isMobile$ | async) {
<div class="cards">
  @for (s of settlements; track s.id) {
  <div class="card">
    <div class="card-head">
      <div class="card-title">
        <span class="supplier-link" (click)="openSupplierInfoDialog(s.supplier_id, s.supplier_name)">{{ s.supplier_name }}</span>
        <p class="card-meta">{{ s.created_at | date:'medium' }}@if (s.kind !== 'Payout') { · {{ s.kind }} }</p>
        @if (s.paid_at) { <p class="card-meta">Paid {{ s.paid_at | date:'medium' }}</p> }
      </div>
      <span class="chip" [ngClass]="settlementClass(s.status)">{{ s.status }}</span>
    </div>
    <div class="amount-row">
      <div>
        <span class="amount-label">Amount (Toman)</span>
        <span class="amount-value">{{ s.amount | number }}</span>
      </div>
      <app-copy-rial-button [amount]="s.amount"></app-copy-rial-button>
    </div>
    @if (s.note) { <p class="card-meta note">{{ s.note }}</p> }
    @if (s.status === 'Paid') {
    <p class="card-meta" [class.missing]="!s.source_account_id">
      Paid from: @if (s.source_account_id) { <bdi>{{ s.source_account_name }}</bdi> } @else { not recorded }
    </p>
    }
    <div class="card-actions">
      @if (coversItems(s)) {
      <button mat-button type="button" (click)="viewItems(s)"><mat-icon>list_alt</mat-icon> {{ itemsLabel(s) }}</button>
      }
      <button mat-button type="button" (click)="editProofs(s)">
        <mat-icon>{{ s.proof_count ? 'image' : 'add_photo_alternate' }}</mat-icon>
        {{ s.proof_count ? 'Proofs (' + s.proof_count + ')' : 'Add proof' }}
      </button>
      @if (canEdit && s.status === 'Paid') {
      <button mat-button type="button" (click)="editPayment(s)"><mat-icon>account_balance</mat-icon> Paid from</button>
      }
      @if (canEdit && s.status !== 'Paid') {
      <button mat-button type="button" class="danger" (click)="remove(s)"><mat-icon>delete</mat-icon> Remove</button>
      <button mat-flat-button type="button" color="primary" (click)="markPaid(s)">
        <mat-icon>check</mat-icon> Mark paid
      </button>
      }
    </div>
  </div>
  }
</div>
} @else {
<div class="table-scroll">
  <table mat-table [dataSource]="settlements">
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let s">{{ s.created_at | date:'short' }}</td>
    </ng-container>
    <ng-container matColumnDef="supplier">
      <th mat-header-cell *matHeaderCellDef>Supplier</th>
      <td mat-cell *matCellDef="let s">
        <span class="supplier-link" matTooltip="View buyer info"
          (click)="openSupplierInfoDialog(s.supplier_id, s.supplier_name)">{{ s.supplier_name }}</span>
        @if (s.kind !== 'Payout') { <div class="sub">{{ s.kind }}</div> }
      </td>
    </ng-container>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>Amount (Toman)</th>
      <td mat-cell *matCellDef="let s">
        <span class="amount-cell">
          <span class="num strong">{{ s.amount | number }}</span>
          <app-copy-rial-button [amount]="s.amount"></app-copy-rial-button>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let s">
        <span class="chip" [ngClass]="settlementClass(s.status)">{{ s.status }}</span>
        @if (s.paid_at) { <div class="sub">{{ s.paid_at | date:'short' }}</div> }
      </td>
    </ng-container>
    <ng-container matColumnDef="paidFrom">
      <th mat-header-cell *matHeaderCellDef>Paid from</th>
      <td mat-cell *matCellDef="let s">
        @if (s.status === 'Paid') {
        <button mat-button type="button" [class.missing]="!s.source_account_id" [disabled]="!canEdit"
          [matTooltip]="s.source_account_id ? 'Edit how this was paid' : 'Record which account this was paid from'"
          (click)="editPayment(s)">
          @if (s.source_account_id) {
          <bdi>{{ s.source_account_name }}</bdi>
          } @else {
          <ng-container><mat-icon>warning</mat-icon> Not recorded</ng-container>
          }
        </button>
        @if (s.bank_fee || s.transaction_ref) {
        <div class="sub">@if (s.bank_fee) { fee {{ s.bank_fee | number }} }@if (s.bank_fee && s.transaction_ref) { · }@if (s.transaction_ref) { #<bdi>{{ s.transaction_ref }}</bdi> }</div>
        }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef>Note</th>
      <td mat-cell *matCellDef="let s">{{ s.note }}</td>
    </ng-container>
    <ng-container matColumnDef="covers">
      <th mat-header-cell *matHeaderCellDef>Pays for</th>
      <td mat-cell *matCellDef="let s">
        @if (coversItems(s)) {
        <button mat-button type="button" matTooltip="Show the runs and contracts this settlement pays" (click)="viewItems(s)">
          <mat-icon>list_alt</mat-icon> {{ itemsLabel(s) }}
        </button>
        } @else {
        <span class="sub">{{ s.kind === 'Payout' ? '—' : s.kind }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="proof">
      <th mat-header-cell *matHeaderCellDef>Proof</th>
      <td mat-cell *matCellDef="let s">
        <button mat-button type="button" [matTooltip]="s.proof_count ? 'View or edit payment proofs' : 'Attach a payment proof'"
          (click)="editProofs(s)">
          <mat-icon>{{ s.proof_count ? 'image' : 'add_photo_alternate' }}</mat-icon>
          {{ s.proof_count ? s.proof_count : 'Add' }}
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let s">
        @if (canEdit && s.status !== 'Paid') {
        <span class="row-actions">
          <button mat-stroked-button type="button" (click)="markPaid(s)">Mark paid</button>
          <button mat-icon-button type="button" class="danger" matTooltip="Remove this unpaid settlement" (click)="remove(s)">
            <mat-icon>delete</mat-icon>
          </button>
        </span>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  </table>
</div>
}

<mat-paginator
  [length]="total"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
  (page)="onPage($event)">
</mat-paginator>
}
</div>
